export default __webpack_public_path__ + "static/media/installAddOnFromFile.2290c3a6.png";